import { Component, Vue, Watch } from 'vue-property-decorator';

import { OrgMgr } from '@/api/index';
import { Regexp } from '@/utils/validate';

@Component
export default class OrgList extends Vue {
  private orgTreeData: object[] = []; // 所有机构树数据
  private currentOrgData: any = null; // 当前机构数据
  private optOrgKey: string = ''; // 新建编辑标识
  // 初始化获取表格数据
  private created() {
    this.getOrgTree();
  }
  // 获取机构树
  private getOrgTree() {
    OrgMgr.getOrgTree().then(res => {
      this.orgTreeData = res.data;
      this.selectedNodeClick(res.data[0]);
    });
  }
  // 机构树节点选中
  private selectedNodeClick(node) {
    this.currentOrgData = node;
    this.currentOrgData.userNames = this.currentOrgData.data.userList.map(item => item.userName ).join(',');
  }
  // 新建机构
  private addOrg() {
    this.dialogFormVisible = true;
    this.optOrgKey = 'add';
    this.loadOptOrgForm();
  }
  // 编辑机构
  private editOrg() {
    this.dialogFormVisible = true;
    this.optOrgKey = 'edit';
    this.loadOptOrgForm();
  }
  // 删除机构
  private deleteOrg(node) {
    this.$confirm('确定删除该机构？', '删除机构', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      OrgMgr.deleteOrg(node.id).then(res => {
        this.getOrgTree();
      });
    });
  }

  /********** 新建、编辑机构管理相关 **********/
  private dialogFormVisible: boolean = false; // 模态框是否展示
  // 新建/编辑Form
  private optOrgForm: any = {
    organName: '',
    description: '',
    userList: []
  };
  private invalid: boolean = true; // 表单按钮是否可用
  private userOptions: object[] = [];
  // 加载新建编辑Form
  private loadOptOrgForm() {
    this.clearOrgForm();
    if (this.optOrgKey === 'edit') {
      this.optOrgForm.organName = this.currentOrgData.name;
      this.optOrgForm.description = this.currentOrgData.data.description;
      this.optOrgForm.userList = this.currentOrgData.data.userList.map(item => item.userId);
      setTimeout(() => {
        (this.$refs.optOrgForm as any).validate();
      }, 300);
    }
    this.getUserOptions();
  }
  // 表单验证规则
  get orgRules(): object {
    return {
      organName: [ Regexp().required, Regexp().maxLength(50), Regexp().minLength(2) ],
      userList: [ Regexp().required ]
    };
  }
  // 实时验证表单 判断确定按钮是否可用
  private validateForm() {
    this.invalid = (this.$refs.optOrgForm as any).fields.some((e: any) =>
      e.isRequired ? e.validateState !== 'success' : e.validateState === 'error'
    );
  }
  // 获取用户列表
  private getUserOptions() {
    OrgMgr.getUserList('', '', '').then(res => {
      this.userOptions = res.data;
    });
  }
  // 保存
  private saveOrg() {
    const users: object[] = [];
    for (const each of this.optOrgForm.userList) {
      users.push({ userId: each });
    }
    const param: any = {
      parentId:  this.currentOrgData.id,
      organName: this.optOrgForm.organName,
      description: this.optOrgForm.description,
      userList: users
    };
    if (this.optOrgKey === 'add') {
      OrgMgr.addOrg(param).then(res => {
        this.dialogFormVisible = false;
        this.optOrgKey = '';
        this.getOrgTree();
      });
    } else {
      param.organId = this.currentOrgData.id;
      param.parentId = this.currentOrgData.parentId;
      OrgMgr.editOrg(param).then(res => {
        this.dialogFormVisible = false;
        this.optOrgKey = '';
        this.getOrgTree();
      });
    }
  }
  // 取消
  private cancleDialog() {
    this.clearOrgForm();
    this.dialogFormVisible = false;
  }
  // 清空Form数据
  private clearOrgForm() {
    this.optOrgForm.organName = '';
    this.optOrgForm.description = '';
    this.optOrgForm.userList = [];
    this.invalid = true;
    setTimeout(() => {
      (this.$refs.optOrgForm as any)?.clearValidate();
    }, 300);
  }
}
